import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http'; 
import { Globals } from '../objects/Globals';
import { environment } from '../../environments/environment';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private serviceUrl: string;
  private currentDateTime: any;

  headerMenu: Subject<any> = new Subject<any>();
  headerMenuChanged$ = this.headerMenu.asObservable();

  selectedMenu: Subject<any> = new Subject<any>();
  selectedMenuChanged$ = this.selectedMenu.asObservable();

  isSessionAlive:Subject<any> = new Subject<any>();
  isSessionAliveChanged$ = this.isSessionAlive.asObservable();

  setCurrentUserDateTime(date: any){
    this.currentDateTime = date;
  }

  getCurrentUserDateTime(){
    return this.currentDateTime;
  }

  displayMenu(display:boolean){
    this.headerMenu.next(display);
  }

  setSelectedMenu(menuCommand: string){
    this.selectedMenu.next(menuCommand);
  }

  setSessionAlive(session:boolean){
    this.isSessionAlive.next(session);
  }
  
  createHeaderCard():Observable<string>{
    var path = this.serviceUrl +"CreateHeaderCard";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, '' , httpOptions);
  }

  getHeaderMenuItems(id:string):Observable<string>{
    var path = this.serviceUrl +"GetHeaderCardMenuActions/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectHeaderMenuItems(id:string, command:string):Observable<string>{
    var path = this.serviceUrl +"SelectHeaderCardMenuAction/"+id+"/"+command;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getTimeZoneList():Observable<string>{
    var path = this.serviceUrl +"GetTimeZoneList";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  setTimeZone(timeZoneId:string):Observable<string>{
    var path = this.serviceUrl +"ChangeUserTimeZone/"+timeZoneId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getTime():Observable<Date>{
    var path = this.serviceUrl +"GetTime";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<Date>(`${path}`, httpOptions);
  }

  updateProfile():Observable<string>{
    var path = this.serviceUrl +"UpdateProfile";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  changePassword():Observable<string>{
    var path = this.serviceUrl +"ChangePassword";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getLatestNotificationDate():Observable<string>{
    var path = this.serviceUrl +"GetLatestNotificationDate";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  notificationsNextPage():Observable<string>{
    var path = this.serviceUrl +"NotificationsNextPage";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getNotifications():Observable<string>{
    var path = this.serviceUrl +"GetNotifications";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  markNotificationsRead():Observable<string>{
    var path = this.serviceUrl +"MarkNotificationsAsRead";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  MarkOneNotificationAsRead(notificationId: string):Observable<string>{
    var path = this.serviceUrl +"MarkOneNotificationAsRead/" + notificationId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getUnreadCount():Observable<string>{
    var path = this.serviceUrl +"GetCurrentUnread";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectNotification(id:string):Observable<string>{
    var path = this.serviceUrl +"SelectNotification/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  performOneTimeAction(userId:string, key:string):Observable<string>{
    var path = this.serviceUrl +"OneTimeAction/"+userId+"/"+key;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true' })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  loginAndAction(userId: string, actionName: string, data: any): Observable<string>{
    var path = this.serviceUrl +"LoginAndAction/"+userId+"/"+actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  actionAndNavigate(id: string, data: any): Observable<string>{
    var path = this.serviceUrl +"ActionAndNavigate?actionKey="+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  actionAndNavigateNew(path: string, userId:string, action: string, data: any): Observable<string>{
    var path = this.serviceUrl +"ActionAndNavigate/" + path + "?userId=" + userId + "&actionKey=" + action;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
    };
    return this.http.post<string>(`${path}`, data, httpOptions);
  }

  endSession():Observable<string>{
    var path = this.serviceUrl +"EndSession";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getUserCommunities():Observable<string>{
    var path = this.serviceUrl +"GetUserCommunities";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  changeCommunity(communityId:string):Observable<string>{
    var path = this.serviceUrl +"ChangeCommunity/" + communityId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  createMenuCard(group:string):Observable<string>{
    var path = this.serviceUrl +"CreateMenuCard/" + group;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getMenuCardMenuActions(id:string):Observable<string>{
    var path = this.serviceUrl +"GetMenuCardMenuActions/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectMenuCardMenuAction(id:string, actionName:string):Observable<string>{
    var path = this.serviceUrl +"SelectMenuCardMenuAction/" + id + "/" + actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  keepSessionAlive():Observable<string>{
    var path = this.serviceUrl +"KeepSessionAlive";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  validateKey(userId:string, oneTimeKey: string):Observable<string>{
    var path = this.serviceUrl +"ValidateKey?SessionKey=" + oneTimeKey + "&UserId=" + userId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true' })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  createLanguageCard():Observable<string>{
    var path = this.serviceUrl +"CreateLanguageCard";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getLanguages(id: string):Observable<string>{
    var path = this.serviceUrl +"GetLanguages/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectLanguage(id:string, locale:string):Observable<string>{
    var path = this.serviceUrl +"SelectLanguage/"+id+"/"+locale;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getPageTour(pageName:any):Observable<string>{
    var path = this.serviceUrl +"GetPageTour";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, pageName, httpOptions);
  }

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { 
    this.serviceUrl = this.env.servicePath;
  }
}
